import { cn } from "@/lib/utils";

interface TypingIndicatorProps {
  className?: string;
}

export function TypingIndicator({ className }: TypingIndicatorProps) {
  return (
    <div className={cn("flex justify-start animate-fade-in", className)}>
      <div className="bg-card border border-border rounded-lg p-3 px-4">
        <div className="flex gap-1.5 items-center">
          <div className="w-2 h-2 bg-primary/60 rounded-full animate-pulse [animation-delay:0ms] [animation-duration:1.4s]"></div>
          <div className="w-2 h-2 bg-primary/60 rounded-full animate-pulse [animation-delay:160ms] [animation-duration:1.4s]"></div>
          <div className="w-2 h-2 bg-primary/60 rounded-full animate-pulse [animation-delay:320ms] [animation-duration:1.4s]"></div>
        </div>
      </div>
    </div>
  );
}
